import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  NgClickOutsideDirective,
  NgClickOutsideExcludeDirective,
} from 'ng-click-outside2';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    imports: [
        NgClass,
        NgIf,
        NgClickOutsideDirective,
        NgClickOutsideExcludeDirective,
    ]
})
export class DropdownComponent {
  /** The unique element identifier. */
  @Input() inputId?: string = 'menuInput';

  /** The text applied to the field label. */
  @Input() label?: string;

  /** Denotes whether this component is a multi-select dropdown.*/
  @Input() isMultiSelect?: boolean = false;

  /** Denotes whether the user is filtering the dropdown. */
  @Input() isFiltering?: boolean = false;

  /** Denotes whether the full width styling should be applied. */
  @Input() isFullWidth?: boolean = false;

  /** Denotes whether the inline title styling should be applied. */
  @Input() isInlineTitle?: boolean = false;

  /** Denotes whether the invalid styling should be applied. */
  @Input() isInvalid?: boolean = false;

  /** Denotes whether the disabled styling should be applied. */
  @Input() isDisabled?: boolean = false;

  /** Denotes whether the field is required. */
  @Input() isRequired?: boolean = false;

  /** The emitter for when the user is done filtering. */
  @Output() doneFiltering = new EventEmitter<void>();

  /** The emitter for when the user is opening the menu. */
  @Output() openingMenu = new EventEmitter<void>();

  isMenuOpen: boolean = false;

  /**
   * This method is called when the user has
   * clicked inside of dropdown.
   * @param showMenu The action of the menu.
   */
  onClickInside(showMenu: boolean): void {
    if (this.#isUserFilteringDropdown(showMenu)) {
      showMenu = true;
    } else if (this.#isUserOpeningDropdown(showMenu)) {
      this.openingMenu.emit();
    }

    this.#setOpenMenu(showMenu);
  }

  /**
   * This method is called when the user has
   * clicked outside of dropdown.
   * @param showMenu The action of the menu.
   */
  onClickOutside(showMenu: boolean): void {
    this.#setOpenMenu(showMenu);
    this.doneFiltering.emit();
  }

  onClickArrow(): void {
    if(this.isMenuOpen){
      this.#setOpenMenu(false);
      this.doneFiltering.emit()
    }
    else {
      this.#setOpenMenu(true)
    }
  }

  /**
   * Sets the showMenu property based on whether the component is disabled.
   * @param showMenu The action of the menu.
   */
  #setOpenMenu(showMenu: boolean): void {
    if (!this.isDisabled) {
      this.isMenuOpen = showMenu;
    }
  }

  /**
   * Determines whether the user is currently filtering the dropdown.
   * @param showMenu The action of the menu.
   * @returns The determination whether the user is filtering the dropdown.
   */
  #isUserFilteringDropdown(showMenu: boolean): boolean {
    if (!!this.isFiltering) {
      return this.isFiltering && !showMenu;
    }
    return false;
  }

  /**
   * Determines whether the user is currently opening the dropdown.
   * @param showMenu The action of the menu.
   * @returns The determination whether the user is opening the dropdown.
   */
  #isUserOpeningDropdown(showMenu: boolean): boolean {
    if (!!this.isFiltering) {
      return !this.isFiltering && showMenu;
    }
    return showMenu;
  }
}
